import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 3a4.375 4.375 0 0 1 4.365 4.07c1.012.28 1.786.531 2.331.757.554.23 1.28.6 2.188 1.117a4.375 4.375 0 0 1 6.172 6.173c.53.936.911 1.684 1.145 2.255.217.53.459 1.282.729 2.264a4.375 4.375 0 0 1 0 8.729c-.265.966-.502 1.707-.716 2.23-.235.579-.62 1.338-1.158 2.288a4.375 4.375 0 0 1-6.171 6.174c-.88.5-1.583.862-2.12 1.087-.56.235-1.357.495-2.4.784a4.375 4.375 0 0 1-8.73.002c-.993-.274-1.754-.52-2.29-.74-.564-.232-1.304-.61-2.229-1.134a4.375 4.375 0 0 1-6.173-6.17c-.484-.849-.835-1.528-1.056-2.046-.244-.576-.514-1.398-.815-2.475a4.375 4.375 0 0 1-.001-8.73c.281-1.016.533-1.793.76-2.34.229-.552.599-1.275 1.112-2.179a4.375 4.375 0 0 1 6.172-6.173c.853-.487 1.535-.84 2.056-1.06.574-.244 1.392-.512 2.464-.81A4.375 4.375 0 0 1 24 3Zm0 29.75a8.75 8.75 0 1 0 0-17.5 8.75 8.75 0 0 0 0 17.5Z",
    fill: "currentColor"
  }));
};

var SvgSettings = styled(SvgComponent).withConfig({
  displayName: "Settings__SvgSettings",
  componentId: "sc-1lp5vd1-0"
})(["", " ", ""], size, color);
export default SvgSettings;